// MARCA | 19/03/2026 | New file - Delivery countdown custom element for announcement bar. Counts down to next-day delivery cutoff (weekday 4pm, Saturday 11am).
// MARCA | 02/04/2026 | Read blocked dates and cutoff hours from data attributes (theme settings) instead of hardcoded values.
// MARCA | 02/04/2026 | Removed hardcoded Sunday skip — delivery runs 7 days a week, blocked dates are managed via theme settings.
if (!customElements.get("delivery-countdown")) {
  class DeliveryCountdown extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.daysEl = this.querySelector(".js-delivery-days");
      this.hoursEl = this.querySelector(".js-delivery-hours");
      this.minsEl = this.querySelector(".js-delivery-mins");
      this.dateEl = this.querySelector(".js-delivery-date");

      this.weekdayCutoff = parseInt(this.dataset.weekdayCutoff, 10) || 16;
      this.saturdayCutoff = parseInt(this.dataset.saturdayCutoff, 10) || 11;
      this.blockedDates = (this.dataset.blockedDates || "")
        .split(",")
        .map((d) => d.trim())
        .filter(Boolean);

      this.updateCountdown();
      this.interval = setInterval(() => this.updateCountdown(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    isNonDeliveryDay(date) {
      const key =
        date.getFullYear() +
        "-" +
        String(date.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(date.getDate()).padStart(2, "0");
      return this.blockedDates.includes(key);
    }

    getCutoffHour(date) {
      return date.getDay() === 6 ? this.saturdayCutoff : this.weekdayCutoff;
    }

    getNextCutoffTime() {
      const now = new Date();
      let candidate = new Date(now);

      while (this.isNonDeliveryDay(candidate)) {
        candidate.setDate(candidate.getDate() + 1);
      }

      const cutoffHour = this.getCutoffHour(candidate);
      let cutoff = new Date(candidate);
      cutoff.setHours(cutoffHour, 0, 0, 0);

      if (now.getTime() > cutoff.getTime()) {
        let nextDay = new Date(candidate);
        do {
          nextDay.setDate(nextDay.getDate() + 1);
        } while (this.isNonDeliveryDay(nextDay));

        cutoff = new Date(nextDay);
        cutoff.setHours(this.getCutoffHour(nextDay), 0, 0, 0);
      }

      return cutoff;
    }

    getNextDeliveryDate(cutoff) {
      const delivery = new Date(cutoff);
      do {
        delivery.setDate(delivery.getDate() + 1);
      } while (this.isNonDeliveryDay(delivery));
      return delivery;
    }

    formatDeliveryDate(date) {
      const dd = date.getDate().toString().padStart(2, "0");
      const mm = (date.getMonth() + 1).toString().padStart(2, "0");
      return dd + "/" + mm;
    }

    updateCountdown() {
      const now = new Date();
      const cutoff = this.getNextCutoffTime();
      const diff = cutoff.getTime() - now.getTime();

      if (diff <= 0) {
        this.daysEl.textContent = "00";
        this.hoursEl.textContent = "00";
        this.minsEl.textContent = "00";
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);

      this.daysEl.textContent = days.toString().padStart(2, "0");
      this.hoursEl.textContent = hours.toString().padStart(2, "0");
      this.minsEl.textContent = minutes.toString().padStart(2, "0");

      if (this.dateEl) {
        this.dateEl.textContent = this.formatDeliveryDate(
          this.getNextDeliveryDate(cutoff),
        );
      }

      this.setAttribute("loaded", "");
    }
  }

  customElements.define("delivery-countdown", DeliveryCountdown);
}
